export default __webpack_public_path__ + "static/moc-hero-0265a92f1e90f3b043f2b5805606285b.png";